module.exports = __webpack_public_path__ + "static/groupChatting-ec421a069e2028402b5bed99e9f08fc7.jpg";